import { render, staticRenderFns } from "./WinningVerifyDetail.vue?vue&type=template&id=5c717230&scoped=true"
import script from "./WinningVerifyDetail.vue?vue&type=script&lang=ts"
export * from "./WinningVerifyDetail.vue?vue&type=script&lang=ts"
import style0 from "./WinningVerifyDetail.vue?vue&type=style&index=0&id=5c717230&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c717230",
  null
  
)

export default component.exports